import { type ReactNode } from "react";

export type KanbanColumn<T> = {
  id: string;
  title: string;
  count?: number;
  items: ReadonlyArray<T>;
  renderItem: (item: T) => ReactNode;
};

export function Kanban<T>({ columns }: { columns: ReadonlyArray<KanbanColumn<T>> }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      {columns.map((c) => (
        <section
          key={c.id}
          className="rounded-xl border border-line bg-canvas-2 overflow-hidden"
        >
          <header className="px-4 py-3 border-b border-line flex items-center justify-between">
            <h3 className="font-medium text-sm text-ink">{c.title}</h3>
            <span className="text-xs text-ink-soft tabular-nums">
              {c.count ?? c.items.length}
            </span>
          </header>
          <div className="p-3 space-y-2 min-h-[6rem]">
            {c.items.length === 0 ? (
              <div className="text-xs text-ink-soft text-center py-6">
                Nothing here.
              </div>
            ) : (
              c.items.map((it, i) => (
                <div
                  key={i}
                  className="rounded-md border border-line bg-canvas p-3 text-sm"
                >
                  {c.renderItem(it)}
                </div>
              ))
            )}
          </div>
        </section>
      ))}
    </div>
  );
}
